export class EqualityParams {
  applyCompetitorPrices!: boolean;
  applyMinProfitabilityLimit!: boolean;

  typeJson: string = 'equality';

  constructor(applyCompetitorPrices: boolean,
              applyMinProfitabilityLimit: boolean) {
    this.applyCompetitorPrices = applyCompetitorPrices;
    this.applyMinProfitabilityLimit = applyMinProfitabilityLimit;
  }
}
